export default {
    label: {
        active: 'Evaluation active',
        inactive: 'Evaluation inactive'
    },
    tooltip: 'The evaluations were deactivated at the level of the trend radar'

}
